import { contabilidadSections } from './contabilidadSections';

export const contabilidadManual = {
  id: 'mod-contabilidad',
  title: 'Contabilidad',
  isVisible: (ctx) => ctx.canSeeContabilidad,
  intro:
    'Reportes contables para usuarios contador o autorizados. Compras diferenciadas documenta consulta mensual, detalle por documento y exportación Excel según la pantalla real del sistema.',
  sections: contabilidadSections,
};
